/**
 * DOM Ready Utility
 * DOMの読み込み完了を待つためのユーティリティ
 * @param {() => void} callback - DOMReadyになったときに実行するコールバック関数
 */
export function domReady(callback) {
  if (document.readyState !== 'loading') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
}
